export const ROGER_POPULATION_INCLUDE_IMPORTED_PATIENTS_KEY =
  'roger_population_include_imported_patients';
export const DASHBOARD_POPULATION_SETTINGS_KEY =
  'dashboard_population_settings_v1';

export function getStoredIncludeImportedPatients(): boolean {
  try {
    const raw = localStorage.getItem(
      ROGER_POPULATION_INCLUDE_IMPORTED_PATIENTS_KEY
    );
    if (raw !== null) {
      return raw === 'true';
    }
  } catch (error) {
    console.error('Failed to read stored includeImportedPatients:', error);
  }
  return false;
}

export function setStoredIncludeImportedPatients(value: boolean): void {
  try {
    localStorage.setItem(
      ROGER_POPULATION_INCLUDE_IMPORTED_PATIENTS_KEY,
      String(value)
    );
  } catch (error) {
    console.error('Failed to save stored includeImportedPatients:', error);
  }
}

export type StoredDashboardPopulationSettings = {
  includeTestPatients: boolean;
  includeImportedPatients: boolean;
};

export function getStoredDashboardPopulationSettings(): StoredDashboardPopulationSettings {
  const globalIncludeImported = getStoredIncludeImportedPatients();
  let includeTestPatients = false;
  try {
    const raw = localStorage.getItem(DASHBOARD_POPULATION_SETTINGS_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      includeTestPatients = Boolean(
        parsed.includeTestPatients ?? parsed.include_test_patients
      );
    }
  } catch (error) {
    console.error(
      'Failed to read stored dashboard population settings:',
      error
    );
  }
  return {
    includeTestPatients,
    includeImportedPatients: globalIncludeImported,
  };
}

export function setStoredDashboardPopulationSettings(
  settings: Partial<StoredDashboardPopulationSettings>
): void {
  try {
    if (settings.includeImportedPatients !== undefined) {
      setStoredIncludeImportedPatients(settings.includeImportedPatients);
    }
    const current = getStoredDashboardPopulationSettings();
    const updated = {
      includeTestPatients:
        settings.includeTestPatients !== undefined
          ? settings.includeTestPatients
          : current.includeTestPatients,
      includeImportedPatients:
        settings.includeImportedPatients !== undefined
          ? settings.includeImportedPatients
          : current.includeImportedPatients,
    };
    localStorage.setItem(
      DASHBOARD_POPULATION_SETTINGS_KEY,
      JSON.stringify(updated)
    );
  } catch (error) {
    console.error(
      'Failed to save stored dashboard population settings:',
      error
    );
  }
}
